export default {
      id: "success-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "sprite.svg#success",
      toString: function () {
        return this.url;
      }
    }